import { extensions } from '../extensions/Extensions.mjs';
import { CanvasFilterSystem } from './CanvasFilterSystem.mjs';
import { FilterPipe } from './FilterPipe.mjs';
import { FilterSystem } from './FilterSystem.mjs';

"use strict";
extensions.add(FilterSystem, CanvasFilterSystem);
extensions.add(FilterPipe);
//# sourceMappingURL=init.mjs.map
